import { useState, useEffect, useRef, useMemo } from "react";
import tw from "tailwind-styled-components";
import Table from "../../Components/Expenses/Table";
import { useNavigate } from "react-router-dom";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { Form, Formik } from "formik";
import AddExpenses from "../../Components/Expenses/AddExpenses";
import EditExpenses from "../../Components/Expenses/EditExpenses";
import ViewExpense from "../../Components/Expenses/ViewExpense";
import SummaryCards from "../../Components/Expenses/SummaryCards";
import { useSelector } from "react-redux";
import moment from "moment";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import { toast } from "react-toastify";
import DeleteExpense from "../../Components/Expenses/DeleteExpense";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import AddVendor from "../../Components/Expenses/AddVendor";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import { IoFilter } from "react-icons/io5";
import EditRecurringExpense from "../../Components/Expenses/EditRecurringExpense";
import MarkAsPaidOfflineModal from "../../Components/Expenses/MarkAsPaidOfflineModal";
import { IoChevronBackOutline } from "react-icons/io5";
import SideModal from "../../Components/SideModal";
import FilterModal from "../../Components/Expenses/FilterModal";
import { MdAdd, MdOutlineCurrencyRupee } from "react-icons/md";
import { GiExpense } from "react-icons/gi";
import AddUnpaidExpenses from "../../Components/Expenses/AddUnpaidExpenses";

const SEARCH_SUMMARY_LABELS = { 1: "Paid by", 2: "Paid to" };

const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(n);

const Expenses = () => {
  const searchOptions = [
    { label: "Paid By", value: 1 },
    { label: "Paid To", value: 2 },
    { label: "Property", value: 4 },
    { label: "Payment Mode", value: 3 },
  ];
  const [showFab, setShowFab] = useState(true);
  const [isEditExpense, setIsEditExpense] = useState(false);
  const [isEditRecurringExpense, setIsEditRecurringExpense] = useState(false);
  const [isMarkPaidExpense, setIsMarkPaidExpense] = useState(false);
  const [isViewExpense, setIsViewExpense] = useState(false);
  const [isShowAddExpense, setIsShowAddExpenses] = useState(false);
  const [isShowAddUnpaidExpenses, setIsShowAddUnpaidExpenses] = useState(false);
  const [propId, setPropId] = useState("");
  const user = useSelector((state) => state.UserReducer.user);
  const [isFocused, setIsFocused] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [expenseData, setExpenseData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("");
  const [editUser, setEditUser] = useState(false);
  const [apiData, setApiData] = useState();
  const [summary, setSummary] = useState({
    totalExpenses: 0,
    curMonthExpenses: 0,
    todayExpenses: 0,
    curMonthRentExpenses: 0,
    curMonthSalaryExpenses: 0,
  });
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const [isAddVendor, setIsAddVendor] = useState(false);
  const [isDeleteExpense, setIsDeleteExpense] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [previousStartDate, setPreviousStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [previousEndDate, setPreviousEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const [startDate, setStartDate] = useState(previousStartDate);
  const [endDate, setEndDate] = useState(previousEndDate);

  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("");
  const navigate = useNavigate();
  const apiCallTimeoutRef = useRef(null);
  const isInitialMount = useRef(true);
  const [sideFilter, setSideFilter] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSortBy, setSelectedSortBy] = useState(null);
  const btnRef = useRef(null);
  const [isFabOpen, setIsFabOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: "",
    endDate: "",
  };

  const query = `&startDate=${startDate}&endDate=${endDate}&propId=${property?.id}&filter=${filter}&s=${searchQuery}&t=${filterType}&typeFilter=${sideFilter}&sortBy=${sortBy}`;

  const fetchInitData = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/initial-values`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    setExpenseData(response.data.data);
  };

  const categories = expenseData?.expenseCategories?.map((section) => ({
    type: "group",
    name: section.name,
    items: section.items.map((item) => ({
      value: item.id + "",
      label: item.name,
    })),
  }));

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      setSummary(res?.data?.summary);
      fetchInitData();
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const searchSummary = useMemo(() => {
    const label = SEARCH_SUMMARY_LABELS[Number(filterType)];
    if (!label || !searchQuery) return null;

    const list = apiData?.list ?? [];
    return {
      label,
      count: list.length,
      total: list.reduce((sum, e) => sum + (Number(e.amount) || 0), 0),
    };
  }, [apiData, filterType, searchQuery]);

  useEffect(() => {
    if (isInitialMount.current) {
      getListMutate();
      isInitialMount.current = false;
      return;
    }

    if (apiCallTimeoutRef.current) {
      clearTimeout(apiCallTimeoutRef.current);
    }

    apiCallTimeoutRef.current = setTimeout(() => {
      getListMutate();
    }, 300);

    return () => {
      if (apiCallTimeoutRef.current) {
        clearTimeout(apiCallTimeoutRef.current);
      }
    };
  }, [
    filter,
    filterValue,
    startDate,
    endDate,
    property,
    filterType,
    searchQuery,
  ]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const isNearBottom =
        scrollTop + windowHeight >= documentHeight - 150;

      setShowFab(!isNearBottom);
    };

    window.addEventListener('scroll', handleScroll);

    return () =>
      window.removeEventListener('scroll', handleScroll);
  }, []);

  const submitHandler = (values) => {
    setFilter("");
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("");
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    setPreviousStartDate(newValues.startDate);
    setPreviousEndDate(newValues.endDate);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleExpansesClose = () => {
    setIsEditExpense(false);
  };
  const handleAddVendorClose = () => {
    setIsAddVendor(false);
  };
  const handleAddExpClose = () => {
    setIsShowAddExpenses(false);
  };
  const handleAddUnpaidExpClose = () => {
    setIsShowAddUnpaidExpenses(false);
  };
  const handleEditRecurringExpClose = () => {
    setIsEditRecurringExpense(false);
  };
  const handleMarkPaidClose = () => {
    setIsMarkPaidExpense(false);
  };

  const handleBackClick = () => {
    setFilter("");
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("");
    setStartDate(previousStartDate);
    setEndDate(previousEndDate);

    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleExpenseSummaryClick = () => {
    navigate("/expense-summary", {
      state: { propId: property?.id },
    });
  };

  //------- Add Expense -------
  const addExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/add/new`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAddExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsShowAddExpenses(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addExpenseLoading, mutate: addExpenseMutate } =
    useMutation(addExpenseFunction, {
      onSuccess: onAddExpenseSuccess,
      onError: onAddExpenseError,
    });

  //------- Edit Expense -------
  const editExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlenced; charset=UTF-8",
      },
    });
  };

  const onEditExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsEditExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editExpenseLoading, mutate: editExpenseMutate } =
    useMutation(editExpenseFunction, {
      onSuccess: onEditExpenseSuccess,
      onError: onEditExpenseError,
    });

  //------- Edit Recurring Expense -------
  const editRecurringExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/edit/recurring`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditRecurringExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsEditRecurringExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditRecurringExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editRecurringExpenseLoading,
    mutate: editRecurringExpenseMutate,
  } = useMutation(editRecurringExpenseFunction, {
    onSuccess: onEditRecurringExpenseSuccess,
    onError: onEditRecurringExpenseError,
  });

  //------- Mark As PAid Expense -------
  const markPaidExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/mark/paidx`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onMarkPaidExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsMarkPaidExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onMarkPaidExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: markPaidExpenseLoading, mutate: markPaidExpenseMutate } =
    useMutation(markPaidExpenseFunction, {
      onSuccess: onMarkPaidExpenseSuccess,
      onError: onMarkPaidExpenseError,
    });

  //------- Delete Expense -------
  const deleteExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/delete`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onDeleteExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsDeleteExpense(false);
      setIsViewExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeleteExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteExpenseLoading, mutate: deleteExpenseMutate } =
    useMutation(deleteExpenseFunction, {
      onSuccess: onDeleteExpenseSuccess,
      onError: onDeleteExpenseError,
    });

  //------- Delete Recurring Expense -------
  const deleteRecurringExpenseFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/expense/delete/recurring`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onDeleteRecurringExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsDeleteExpense(false);
      setIsViewExpense(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeleteRecurringExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: deleteRecurringExpenseLoading,
    mutate: deleteRecurringExpenseMutate,
  } = useMutation(deleteRecurringExpenseFunction, {
    onSuccess: onDeleteRecurringExpenseSuccess,
    onError: onDeleteRecurringExpenseError,
  });

  //------- Add vendor -------
  const addVendorFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/vendor/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddVendorSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsAddVendor(false);
      // setIsShowAddExpenses(true);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddVendorError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: addVendorLoading,
    mutate: addVendorMutate,
    data: vendorList,
  } = useMutation(addVendorFunction, {
    onSuccess: onAddVendorSuccess,
    onError: onAddVendorError,
  });

  const onSummaryBoxClick = (data) => {
    setFilter(data);
    setFilterType("");
    setSearchQuery("");
    //setStartDate("");
    //setEndDate("");
    setActiveFilter("");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleFilterChange = (values) => {
    setStartDate("");
    setEndDate("");
    setFilter("");
    setActiveFilter("");
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 500);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleClearFilters = () => {
    setFilter("");
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("");
    setStartDate(previousStartDate);
    setEndDate(previousEndDate);
  };

  const getDateRangeDisplayText = () => {
    if (
      startDate &&
      endDate &&
      moment(startDate).isValid() &&
      moment(endDate).isValid()
    ) {
      return (
        moment(startDate).format("DD MMM yyyy") +
        " - " +
        moment(endDate).format("DD MMM yyyy")
      );
    }
    return "Select Date Range";
  };

  const onApplyFilter = (value, label, sortByValue) => {
    setSideFilter(value);
    setSortBy(sortByValue);
    setFilterType("");
    setSearchQuery("");
    setActiveFilter("1");
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
  };

  const handleFilterClose = () => {
    setSelectedCategory("");
    setActiveFilter("");
    setSideFilter("");
    setSortBy("");
    setFilterType("");
    setSearchQuery("");
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
  };

  //------- Add Unpaid Expense -------
  const addUnpaidExpenseFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/add/unpaid`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAddUnpaidExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsShowAddUnpaidExpenses(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddUnpaidExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addUnpaidExpenseLoading, mutate: addUnpaidExpenseMutate } =
    useMutation(addUnpaidExpenseFunction, {
      onSuccess: onAddUnpaidExpenseSuccess,
      onError: onAddUnpaidExpenseError,
    });

  const handleFabClick = () => {
    setIsFabOpen(!isFabOpen);
  };

  const handleAddPaidExpense = () => {
    setIsShowAddExpenses(true);
    setIsFabOpen(false);
  };

  const handleAddUnpaidExpense = () => {
    setIsShowAddUnpaidExpenses(true);
    setIsFabOpen(false);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          <div className="flex items-center">
            {(filter === "RE" || filter === "UM") && (
              <button
                onClick={handleBackClick}
                className="hover:bg-gray-200  items-center -mt-1 p-1 rounded-full transition-colors"
              >
                <IoChevronBackOutline size={20} />
              </button>
            )}
            <div>
              <span className="flex items-center ">
                {"Expenses"}
              </span>
              <Underline />
            </div>
          </div>
        </BoxTitle>

        {filter !== "RE" && filter !== "UM" && (
          <Filters
            submitHandler={submitHandler}
            initialValues={initialValues}
            setIsShowAddExpenses={setIsShowAddExpenses}
            user={user}
            onExpenseSummaryClick={handleExpenseSummaryClick}
          />
        )}
      </BoxHead>

      <SideModal isOpen={isEditExpense} onClose={() => setIsEditExpense(false)}>
        <EditExpenses
          setIsEditExpense={setIsEditExpense}
          isEditExpense={isEditExpense}
          handleClose={handleExpansesClose}
          editExpenseLoading={editExpenseLoading}
          editExpenseMutate={editExpenseMutate}
          selectedData={selectedData}
          expenseData={expenseData}
          categories={categories}
          setIsDeleteExpense={setIsDeleteExpense}
          setPropId={setPropId}
          property={propertyList}
        />
      </SideModal>

      <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
        <FilterModal
          setIsFilterOpen={setIsFilterOpen}
          onApplyFilter={onApplyFilter}
          selectedData={selectedData}
          handleClose={() => setIsFilterOpen(false)}
          handleClear={handleFilterClose}
          categories={categories}
          selected={null}
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
          setSelectedSortBy={setSelectedSortBy}
          selectedSortBy={selectedSortBy}
        />
      </SideModal>

      <SideModal
        isOpen={isEditRecurringExpense}
        onClose={() => setIsEditRecurringExpense(false)}
      >
        <EditRecurringExpense
          setIsEditRecurringExpense={setIsEditRecurringExpense}
          isEditRecurringExpense={isEditRecurringExpense}
          handleClose={handleEditRecurringExpClose}
          editRecurringExpenseLoading={editRecurringExpenseLoading}
          editRecurringExpenseMutate={editRecurringExpenseMutate}
          selectedData={selectedData}
          expenseData={expenseData}
          categories={categories}
          setIsDeleteExpense={setIsDeleteExpense}
          setPropId={setPropId}
          property={propertyList}
        />
      </SideModal>

      <SideModal
        isOpen={isMarkPaidExpense}
        onClose={() => setIsMarkPaidExpense(false)}
      >
        <MarkAsPaidOfflineModal
          setIsMarkPaidExpense={setIsMarkPaidExpense}
          isMarkPaidExpense={isMarkPaidExpense}
          handleClose={handleMarkPaidClose}
          markPaidExpenseLoading={markPaidExpenseLoading}
          markPaidExpenseMutate={markPaidExpenseMutate}
          selectedData={selectedData}
          expenseData={expenseData}
        />
      </SideModal>

      <SideModal isOpen={isViewExpense} onClose={() => setIsViewExpense(false)}>
        <ViewExpense
          setIsViewExpense={setIsViewExpense}
          selectedData={selectedData}
          setIsEditExpense={setIsEditExpense}
          setIsDeleteExpense={setIsDeleteExpense}
          setIsEditRecurringExpense={setIsEditRecurringExpense}
          setPropId={setPropId}
          filter={filter}
        />
      </SideModal>

      <SideModal
        isOpen={isShowAddExpense}
        onClose={() => setIsShowAddExpenses(false)}
      >
        <AddExpenses
          expenseData={expenseData}
          vendorList={vendorList?.data?.vendors}
          categories={categories}
          addExpenseMutate={addExpenseMutate}
          addExpenseLoading={addExpenseLoading}
          handleClose={handleAddExpClose}
          setIsAddVendor={setIsAddVendor}
          setIsShowAddExpenses={setIsShowAddExpenses}
          property={propertyList}
          addUnpaidExpenseLoading={addUnpaidExpenseLoading}
          addUnpaidExpenseMutate={addUnpaidExpenseMutate}
        />
      </SideModal>

      <SideModal
        isOpen={isShowAddUnpaidExpenses}
        onClose={() => setIsShowAddUnpaidExpenses(false)}
      >
        <AddUnpaidExpenses
          expenseData={expenseData}
          vendorList={vendorList?.data?.vendors}
          categories={categories}
          handleClose={handleAddUnpaidExpClose}
          setIsAddVendor={setIsAddVendor}
          setIsShowAddExpenses={setIsShowAddExpenses}
          property={propertyList}
          addUnpaidExpenseLoading={addUnpaidExpenseLoading}
          addUnpaidExpenseMutate={addUnpaidExpenseMutate}
        />
      </SideModal>

      <SideModal isOpen={isAddVendor} onClose={() => setIsAddVendor(false)}>
        <AddVendor
          addVendorMutate={addVendorMutate}
          addVendorLoading={addVendorLoading}
          handleClose={handleAddVendorClose}
        />
      </SideModal>

      {isDeleteExpense && (
        <DeleteExpense
          deleteExpenseMutate={deleteExpenseMutate}
          deleteRecurringExpenseMutate={deleteRecurringExpenseMutate}
          deleteExpenseLoading={deleteExpenseLoading}
          deleteRecurringExpenseLoading={deleteRecurringExpenseLoading}
          setIsDeleteExpense={setIsDeleteExpense}
          selectedData={selectedData}
          propId={propId}
          setIsViewExpense={setIsViewExpense}
          filter={filter}
        />
      )}
      {filter !== "RE" && filter !== "UM" && (
        <>
          {(isLoading || isRefetching) && !isFocused && (
            <SummarySkeletonLoading count={6} />
          )}
          {isFocused && apiData && (
            <SummaryCards summaryData={summary} onClick={onSummaryBoxClick} />
          )}
        </>
      )}
      <FilterTableWrapper $filter={filter}>
        {filter !== "RE" && filter !== "UM" && (
          <FilterWrapper>
            {/* <div className="flex xl:space-x-4 flex-col xl:flex-row gap-4 xl:gap-0 items-stretch w-full"> */}
            <div className="flex flex-col sm:flex-row gap-4 lg:gap-4 flex-1 min-w-0">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilters}
                className="flex-1 min-w-0"
              />
              {filter !== "RE" && filter !== "UM" && (
                <DateRange
                  submitHandler={submitHandler}
                  defaultLabel={getDateRangeDisplayText()}
                  className="flex-1 min-w-0"
                />
              )}

              <div className="relative ml-auto">
                <FilterBtn
                  ref={btnRef}
                  type="button"
                  title="Category Filter"
                  onClick={() => setIsFilterOpen((v) => !v)}
                  className={`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto}`}
                >
                  <IoFilter size={14} color="#9CA3AF" />
                </FilterBtn>
                {/* Yellow dot when filter is applied */}
                {activeFilter && (
                  <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"></span>
                )}
              </div>

            </div>

          </FilterWrapper>
        )}
        {!error && !isLoading && data && (
          <TableWrapper $filter={filter}>
            {searchSummary && (
              <div className="flex items-center justify-between gap-4 px-4 py-3 mb-3 bg-slate-100 text-sm">
                <span className="text-slate-600 truncate">
                  {searchSummary.label}{" "}
                  <span className="font-semibold text-slate-800">"{searchQuery}"</span>
                  <span className="ml-2 text-slate-500">
                    ({searchSummary.count} expenses)
                  </span>
                </span>
                <span className="font-semibold text-slate-900 whitespace-nowrap">
                  Total: {formatINR(searchSummary.total)}
                </span>
              </div>
            )}
            <Table
              apiData={error ? [] : apiData.list}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setEditUser={setEditUser}
              setViewDetail={setViewDetail}
              userType={user.userType}
              setIsViewExpense={setIsViewExpense}
              filter={filter}
              setIsDeleteExpense={setIsDeleteExpense}
              setIsMarkPaidExpense={setIsMarkPaidExpense}
              currentPageIndex={currentPageIndex}
              setCurrentPageIndex={setCurrentPageIndex}
              sortBy={sortBy}
            />
            {(error || apiData.list.length === 0) && !isLoading && (
              <NotFoundModel />
            )}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {(isLoading || isRefetching) && <Loading />}
      {/* {!isLoading && !isRefetching && (
        <FabButton
          // onClick={() => setIsAddNoteModalOpen(true)}
          aria-label="Add Expense"
        >
          <MdAdd size={24} />
        </FabButton>
      )} */}
      {showFab && !isLoading && !isRefetching && (
        <FabContainer>
          {/* Two buttons that appear above the FAB */}
          {isFabOpen && (
            <div className="w-64 bg-white border border-gray-100 rounded-2xl shadow-xl overflow-hidden">

              {/* Header */}
              <div className="px-4 py-3 border-b border-gray-100">
                <p className="text-xs text-gray-500 uppercase tracking-wide">
                  Expenses
                </p>
                <h3 className="text-sm font-semibold text-gray-800">
                  Add New Expense
                </h3>
              </div>

              {/* Paid Expense */}
              <button
                onClick={handleAddPaidExpense}
                className="group flex items-start gap-3 w-full px-4 py-4 transition-all duration-200 hover:bg-gray-50"
              >
                <div className="p-2 rounded-lg bg-green-50 group-hover:bg-green-100 transition">
                  <MdOutlineCurrencyRupee size={18} className="text-green-600" />
                </div>

                <div className="text-left">
                  <p className="text-sm font-semibold text-gray-800">
                    Record Paid Expense
                  </p>
                  <p className="text-xs text-gray-500">
                    Money already paid
                  </p>
                </div>
              </button>

              {/* Divider */}
              <div className="h-px bg-gray-100 mx-3" />

              {/* Unpaid Expense */}
              <button
                onClick={handleAddUnpaidExpense}
                className="group flex items-start gap-3 w-full px-4 py-4 transition-all duration-200 hover:bg-gray-50"
              >
                <div className="p-2 rounded-lg bg-amber-50 group-hover:bg-amber-100 transition">
                  <GiExpense size={18} className="text-amber-600" />
                </div>

                <div className="text-left">
                  <p className="text-sm font-semibold text-gray-800">
                    Record Pending Expense
                  </p>
                  <p className="text-xs text-gray-500">
                    Payment due later
                  </p>
                </div>
              </button>

            </div>
          )}

          {/* Main FAB button */}
          <FabButton
            onClick={handleFabClick}
            $isOpen={isFabOpen}
          >
            <MdAdd size={24} className={`transition-transform duration-200 ${isFabOpen ? 'rotate-45' : ''}`} />
          </FabButton>
        </FabContainer>
      )}
    </BoxContainer>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  setIsShowAddExpenses,
  onExpenseSummaryClick,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <SummaryBtn type="button" onClick={onExpenseSummaryClick}>
            {"Expense Summary"}
          </SummaryBtn>
          {/* <AddBtn
            type="button"
            onClick={() => {
              setIsShowAddExpenses(true);
            }}
          >
            {"Add Expenses"}
          </AddBtn> */}
        </FilterContainer>
      </Form>
    </Formik>
  );
};

// const TableWrapper = tw.h1`my-4 bg-white rounded-md `;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const SummaryBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-primary-color/5 hover:shadow-md h-full py-2.5 text-sm`;
const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const FilterTableWrapper = tw.div`
  ${(p) =>
    p.$filter === "UM" || p.$filter === "RE" ? "py-0 mt-0" : "py-4 mt-4"}
  bg-white rounded-lg border
`;
const TableWrapper = tw.div`
  ${(p) => (p.$filter === "UM" || p.$filter === "RE" ? "my-0" : "mt-4")}
  bg-white rounded-md
`;
const FilterBtn = tw.button``;
const FabContainer = tw.div`
  fixed 
  bottom-20 
  right-6 
  md:right-10 
  flex 
  flex-col 
  items-end 
  z-10
`;

const FabOptions = tw.div`
  flex 
  flex-col 
  gap-3 
  mb-4
  animate-fade-in-up
`;

const FabOptionButton = tw.button`
  py-2 px-3
  text-white 
  rounded-lg 
   transition-all 
  duration-200 
  text-sm 
  font-medium
  whitespace-nowrap
  items-center
`;

// Update your existing FabButton to accept $isOpen prop
const FabButton = tw.button`
  w-12
  h-12 
  bg-primary-color 
  hover:bg-primary-color/80 
  text-white 
  rounded-full 
  flex 
  items-center 
  justify-center 
  shadow-lg 
  hover:shadow-xl 
  transition-all 
  duration-200
  ${(p) => p.$isOpen ? 'bg-primary-color/80' : ''}
`;
// const FabButton = tw.button`fixed bottom-6 right-6 md:right-10 w-14 h-14 bg-primary-color hover:bg-primary-color/80 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-200 z-50`;
export default Expenses;
